export const getStyles = (tabWidth: string, hasBanner: boolean) => {
  const styles = {
    root: {
      position: "fixed",
      top: hasBanner ? 100 : 60,
      bottom: 0,
      right: tabWidth,
      zIndex: 100,
    },
    active: {
      borderRadius: 0,
      borderRight: `3px solid #3E633E`,
    },
    icon: {
      color: "#A2BDA2",
      fontSize: 20,
      py: 1,
    },
  };
  return styles;
};
